var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"earnings-card"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{attrs:{"id":"chart"}},[_c('vue-apex-charts',{attrs:{"height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }